export enum CommissionPromotionType {
  LEVEL = "LEVEL",
  RANK = "RANK",
}

export enum CommissionPromotionStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}
